import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core'
import { MatMenu } from '@angular/material/menu'
import { ApiService, MessageTemplateModel } from '@mmx/shared'

@Component({
  selector: 'mmx-template-message',
  templateUrl: './template-message.component.html',
  styleUrls: ['./template-message.component.scss'],
  standalone: false,
})

export class TemplateMessageComponent implements OnInit {
  @Input() language: string
  @Output() templateMessage = new EventEmitter<string>()
  @ViewChild(MatMenu, { static: true }) menu: MatMenu
  templates: MessageTemplateModel[]

  constructor(
    private api: ApiService,
  ) {}

  ngOnInit(): void {
    this.getTemplates()
  }

  getTemplates() {
    if (this.templates != null) {
      return
    }
    this.api
      .getMessageTemplates({
        includeWorkflowTemplates: false,
        includeSystemTemplates: false,
      })
      .subscribe((templates) => {
        this.templates = templates || []
      })
  }

  useTemplate(template: MessageTemplateModel) {
    const language = this.language || 'en'
    if (template.textTemplate) {
      if (template.textTemplate[language]) {
        this.templateMessage.emit(template.textTemplate[language])
      }
    }
  }
}
